module.exports = __webpack_public_path__ + "media/thumbnails/head-style-2-11d6d38f.svg";